module.exports = __webpack_public_path__ + "img/pos-wristband.1a8ad3a2.png";